var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "row relative"
  }, [_vm.loading ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row mt-5 pt-5"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "col-md-12"
  })])]) : _vm._e(), !_vm.loading ? _c('div', {
    staticClass: "col-md-12 my-4"
  }, [_c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_c('div', {
    staticClass: "form_contain"
  }, [_c('el-input', {
    staticClass: "search_item",
    attrs: {
      "placeholder": "search user",
      "clearable": true,
      "size": 'large'
    },
    on: {
      "input": _vm.searchSenderIDs
    },
    model: {
      value: _vm.search,
      callback: function ($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  }, [_c('i', {
    staticClass: "el-input__icon el-icon-search",
    staticStyle: {
      "padding-to": "2em"
    },
    attrs: {
      "slot": "prefix"
    },
    slot: "prefix"
  })])], 1)])]) : _vm._e(), !_vm.loading ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.tableLoading,
      expression: "tableLoading"
    }],
    ref: "senderIDTable",
    staticStyle: {
      "width": "100vw",
      "overflow-x": "auto !important"
    },
    attrs: {
      "data": _vm.displayData,
      "header-cell-style": {
        background: 'rgba(212, 216, 226, 0.2)'
      },
      "empty-text": 'No Data Available',
      "height": "55vh"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _c('el-table-column', {
    attrs: {
      "label": "Phone Number",
      "prop": "phone",
      "width": "150"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "sender_id",
      "label": "Sender ID",
      "width": "150"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "purpose",
      "label": "Purpose",
      "width": "150"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "Status",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c('div', {
          staticClass: "__status_wrapper"
        }, [_c('button', {
          staticClass: "status_text",
          class: _vm.statusTextClasss(scope.row.status)
        }, [_vm._v(" " + _vm._s(_vm.statusText(scope.row.status)) + " ")])])];
      }
    }], null, false, 3431617819)
  }), _c('el-table-column', {
    attrs: {
      "label": "Time Created",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c('span', [_vm._v(" " + _vm._s(_vm.moment(scope.row.created_at).format("DD MMM YYYY hh:mm A")) + " ")])];
      }
    }], null, false, 1229331303)
  }), _c('el-table-column', {
    attrs: {
      "label": "Time Updated",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c('span', [_vm._v(" " + _vm._s(_vm.moment(scope.row.updated_at).format("DD MMM YYYY hh:mm A")) + " ")])];
      }
    }], null, false, 4050043506)
  }), !_vm.$route.path.includes('autoApproved') && !_vm.$route.path.includes('pending') ? _c('el-table-column', {
    attrs: {
      "prop": "approved_by",
      "label": "Approved By",
      "width": "150"
    }
  }) : _vm._e(), _c('el-table-column', {
    attrs: {
      "label": "Action",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm.showApprovedButton ? _c('button', {
          staticClass: "approve",
          attrs: {
            "id": "enter__account"
          },
          on: {
            "click": function ($event) {
              return _vm.approve(scope);
            }
          }
        }, [_vm._v(" Approve ")]) : _vm._e(), _vm.showDeclineButton ? _c('button', {
          staticClass: "decline",
          attrs: {
            "id": "enter__account"
          },
          on: {
            "click": function ($event) {
              return _vm.disapprove(scope);
            }
          }
        }, [_vm._v(" Decline ")]) : _vm._e(), (_vm.showReserveButton, _vm.$route.path.includes('approved') || _vm.$route.path.includes('autoApproved')) ? _c('button', {
          staticClass: "reserve",
          attrs: {
            "id": "enter__account"
          },
          on: {
            "click": function ($event) {
              return _vm.reserve(scope);
            }
          }
        }, [_vm._v(" Reserve ")]) : _vm._e(), _vm.showPendingUserVerification ? _c('button', {
          staticClass: "monitor",
          attrs: {
            "id": "enter__account"
          },
          on: {
            "click": function ($event) {
              return _vm.monitor(scope);
            }
          }
        }, [_vm._v(" Hold ")]) : _vm._e()];
      }
    }], null, false, 4144914721)
  })], 1)], 1) : _vm._e(), !_vm.loading ? _c('div', {
    staticClass: "col-md-12 mb-4",
    staticStyle: {
      "text-align": "center",
      "margin-top": "2em"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e(), _c('ActionModal', {
    ref: "actionModal",
    attrs: {
      "payload": _vm.actionModalPayload
    },
    on: {
      "close": _vm.closeModal,
      "needsToRefresh": _vm.fetchSenderIDsFromStore
    }
  }), _c('el-dialog', {
    attrs: {
      "title": "Confirm Reserve Sender ID",
      "visible": _vm.showReserveID,
      "width": "40%"
    },
    on: {
      "update:visible": function ($event) {
        _vm.showReserveID = $event;
      }
    }
  }, [_c('p', [_vm._v("Are you sure you want to reserve this Sender Id?")]), _c('p', [_vm._v(" Sender ID: "), _c('strong', [_c('em', [_vm._v(_vm._s(_vm.reserveIdData.sender_id))])])]), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.showReserveID = false;
      }
    }
  }, [_vm._v("Cancel")]), _c('el-button', {
    attrs: {
      "type": "danger",
      "loading": _vm.buttonLoading
    },
    on: {
      "click": _vm.submitAction
    }
  }, [_vm._v("Confirm")])], 1)]), _c('transition', {
    attrs: {
      "name": "el-fade-in-linear"
    }
  }, [_vm.multiSelectActive ? _c('userMultiAction', {
    attrs: {
      "multiSelectedData": _vm.multiSelectedData
    },
    on: {
      "update:visible": _vm.cancelMultiSelect
    }
  }) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };